import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// تطبيق الوضع المظلم إذا كان مفضلاً
if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.documentElement.setAttribute('data-bs-theme', 'dark');
    updateThemeIcons('dark');
} else {
    document.documentElement.setAttribute('data-bs-theme', 'light');
    updateThemeIcons('light');
}

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    if (event.matches) {
        document.documentElement.setAttribute('data-bs-theme', 'dark');
        updateThemeIcons('dark');
    } else {
        document.documentElement.setAttribute('data-bs-theme', 'light');
        updateThemeIcons('light');
    }
});

// وظيفة لتحديث أيقونات الوضع
function updateThemeIcons(theme) {
    setTimeout(() => {
        const darkIcons = document.querySelectorAll('.dark-mode-only');
        const lightIcons = document.querySelectorAll('.light-mode-only');
       
        if (theme === 'dark') {
            darkIcons.forEach(icon => icon.classList.remove('d-none'));
            lightIcons.forEach(icon => icon.classList.add('d-none'));
        } else {
            darkIcons.forEach(icon => icon.classList.add('d-none'));
            lightIcons.forEach(icon => icon.classList.remove('d-none'));
        }
    }, 0);
}

// إضافة event listener للزر
document.addEventListener('click', function(e) {
    if (e.target.closest('button') && e.target.closest('button').getAttribute('onClick')?.includes('toggleDarkMode')) {
        const currentTheme = document.documentElement.getAttribute('data-bs-theme');
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        updateThemeIcons(newTheme);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);